import {
    getAccessibleCunluoList,
    getAccessibleCunluoNames,
    getAccessibleCunluoAdcdList,
    getAccessibleCunluoAdcdIds
} from '@/config/cunluo'
import { getPlatformTitle } from '@/config/villages'

const getters = {
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    userInfo: state => state.user.userpermission?.data || {},
    platformTitle: state => getPlatformTitle(state.user.userpermission?.data || {}),
    accessibleCunluoList: state => getAccessibleCunluoList(state.user.userpermission?.data || {}),
    accessibleCunluoNames: state => getAccessibleCunluoNames(state.user.userpermission?.data || {}),
    accessibleCunluoAdcdList: state => getAccessibleCunluoAdcdList(state.user.userpermission?.data || {}),
    accessibleCunluoAdcdIds: state => getAccessibleCunluoAdcdIds(state.user.userpermission?.data || {})
}
export default getters
